module.exports = __webpack_public_path__ + "static/media/countdownM.fc1b0a47.jpg";